export default __webpack_public_path__ + "static/media/walkwithdeath.6aa0d142.png";